import legacyPathRedirect from '../../../config/legacyPathRedirect'

export default {
  PATH: legacyPathRedirect.PATH,
  resolvePathname: legacyPathRedirect.resolvePathname,
}
